import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import SecretariaLogged from '../../../../components/auth/institucional/secretaria'

function SecretariaLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Secretarias" />
                <HeaderLogged />
                <Container>
                   <SecretariaLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default SecretariaLoggedScreen;